<style scoped lang="scss" type="text/scss">
    .robot-container {
        .robot-items {
            margin: -1rem 0 0 -1rem;
            display: flex;
            flex-wrap: wrap;

            .robot-item {
                height: 9rem;
                margin: 1rem 0 0 1rem;
                width: calc(50% - 1rem);
            }
        }
    }
</style>

<template>
    <div class="robot-container">
        <block-divider>机器人</block-divider>

        <div class="robot-items">
            <add-block class="robot-item" title="机器人" reversed @click.native="showEditor"></add-block>

            <robot-item class="robot-item" v-for="(robot, index) in robots" :key="index"
                        :editable="true" :info="robot" :index="index + 1"
                        @call-edit="showUpdateEditor(robot.id, ...arguments)"
                        @call-remove="remove(robot.id, ...arguments)"
            >
            </robot-item>
        </div>

        <popup :visible.sync="isEditorVisible"
               :is-update="isUpdateMode"
               :id="updateId"
               :deletable="isUpdateMode"
               @need-reload="loadPlayerRobots"
        >
        </popup>
    </div>
</template>

<script>
    import BlockDivider from '../../../../../components/divider/block';
    import RobotItem from '../../../../sub-components/robot-item/index';
    import AddBlock from '../../../../../components/add-block/index';
    import Popup from './popup';
    import {mapState} from 'vuex';

    export default {
        name: '',
        components: {
            BlockDivider,
            RobotItem,
            AddBlock,
            Popup
        },
        data () {
            return {
                isEditorVisible: false,
                deletable: false,
                isUpdateMode: false,
                updateId: null
            };
        },
        computed: {
            ...mapState('player', {
                currentManagedPlayerId: state => state.currentManagedPlayerId,
                robots: state => state.currentManagedPlayerRobots
            })
        },
        watch: {
            currentManagedPlayerId: {
                immediate: true,
                handler (currentManagedPlayerId) {
                    if (currentManagedPlayerId === null || currentManagedPlayerId === undefined) return;
                    this.loadPlayerRobots();
                }
            }
        },
        methods: {
            loadPlayerRobots () {
                return this.$store.dispatch('player/loadRobots', {
                    id: this.currentManagedPlayerId
                }).then(response => {
                }).catch(_ => {
                });
            },
            showEditor () {
                this.updateId = null;
                this.isUpdateMode = false;
                this.isEditorVisible = true;
            },
            showUpdateEditor (id, callback) {
                this.updateId = id;
                this.isUpdateMode = true;
                this.isEditorVisible = true;
                callback();
            },
            remove (id, callback) {
                this.$deleteConfirm().then(_ => {
                    this.$normalRequest('player/deleteRobot', {id}, '删除成功').then(_ => {
                        this.loadPlayerRobots().then(_ => {
                            callback();
                        });
                    }).catch(_ => {
                        callback();
                    });
                }).catch(_ => {
                    callback();
                });
            }
        }
    };
</script>
